<template>
    <div id="login-app" class="d-flex">

        <v-row cols="12">

            <v-col class="background-div p-0" :style="`background: url(${bgLogin}) no-repeat center top;`">
                <div class="container container-col-box" :class="$vuetify.breakpoint.smAndDown  ? 'd-block text-center' : 'd-flex'">
                    <div class="row align-items-end justify-left">
                        <div class="col-12">
                            <div class="box--logo">
                                <p class="p-left title">{{titleLogin}}</p>
                                <p class="p-left subtitle">{{subTitleLogin}}</p>
                            </div>


                            <div class="copyright  mb-50" :class="$vuetify.breakpoint.smAndDown  ? 'd-none' : ''">{{year}} {{ $t('reserved-rights') }}</div>
                        </div>

                    </div>


                    <v-row class="align-items-center " :class="$vuetify.breakpoint.smAndDown  ? 'justify-center' : 'justify-left'" v-if="!isRecovery && !isRegister">
                        <div class="login-div">
                            <div class="row-form-login">

                                <div class="div-form-logo">
                                    <img :src="logo" />
                                </div>

                                <div class="div-form-title  mb-4">
                                    <span>{{ $t('reset-password') }}</span>
                                    <p class="p-right"></p>
                                </div>


                                <v-form @submit.prevent="postResetPassword" v-model="valid" autocomplete="off"  v-show="!showReset">
                                    <v-text-field
                                        v-model="password"
                                        type="password"
                                        :label="$t('password')"
                                        filled
                                        autocomplete="off"
                                        background-color="#fff"
                                        :rules="[rulesPassword.required, rulesPassword.min]"
                                    />

                                    <v-text-field
                                        v-model="confirmPassword"
                                        type="password"
                                        :label="$t('confirm-password')"
                                        filled
                                        autocomplete="off"
                                        background-color="#fff"
                                        :rules="[rulesPassword.required, rulesPassword.min, rulesPassword.verify]"
                                    />

                                    <div class="col-8 mx-auto offset-1 btn-login">
                                        <button type="submit" class="btn btn-primary btn-block" :disabled="!valid">
                                            {{ $t('go-login') }}
                                        </button>
                                    </div>


                                    <v-row cols="12" class="d-flex flex-row">
                                        <!--<v-col cols="12" sm="6" class="mx-auto text-center">
                                            <v-checkbox v-model="checkbox" hide-details label="Lembrar sessão" class="text-center mx-auto mt-0" color="#fff"></v-checkbox>
                                        </v-col>-->

                                        <v-col cols="12" class="text-center btn-recover  align-self-center pb-0 mt-3">
                                            <v-btn class="white--text" style="padding: 0px;font-size:11px;" text @click="isRecovery = true">{{ $t('access-recovery') }}</v-btn>
                                        </v-col>

                                        <v-col sm="12" class="text-center align-self-center p-0">
                                            <v-btn class="white--text" style="padding: 0px; font-size:11px;" text @click="isRegister = true">{{ $t('create-account') }}</v-btn>
                                        </v-col>
                                    </v-row>

                                </v-form>

                                <div class="div-form-title mt-14 mb-6" v-show="showReset">

                                    <p class="mt-3" style="font-size: 14px;">
                                        {{ $t('update-success') }}
                                    </p>
                                </div>
                                <v-row cols="12" class="d-flex flex-row" v-show="showReset">

                                    <v-col sm="12" class="text-center align-self-center">
                                        <v-btn class="white--text" style="padding: 0px" text @click="$router.push('/')">{{ $t('back-to-login') }}</v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-row>



                    <v-row :class="$vuetify.breakpoint.smAndDown  ? 'mt-10' : 'd-none'">
                        <v-col cols="12">
                            <div class="copyright">{{year}} {{ $t('reserved-rights') }}</div>
                        </v-col>
                    </v-row>
                </div>



            </v-col>



        </v-row>


    </div>
</template>


<script>
import { AuthServicesResetPassword } from "@services/AuthServices";
import { required, minLength, maxLength, isEmail } from '@src/utils/validations.js';
export default {
    name: "login-internal",
    data() {
        return {
            isValidEnv: process.env.VUE_APP_DOMAIN,
            token:"",
            password: "",
            confirmPassword: "",
            valid: false,

            rulesEmail: [v => !!v || this.$t('required-input'), v => isEmail(v) || this.$t('email-validate-input')],
            rulesPassword: {
                required: value => !!value || this.$t('required-input'),
                min: v => (v != undefined && v.length >= 8) || this.$t('min-8-chars'),
                verify: v=> v === this.password || this.$t('diff-password')
            },

            rulesRequired: [required],

            rulesTel: [required, maxLength(9), minLength(9)],

            modalRequest: {
                show: false,
                message: '',
                invalid: false,
            },

            year: '',

            showReset:false

        };
    },

    methods: {
        postResetPassword(){
            let body = {
                newPassword: this.password,
            }

            this.$store.commit("loadings/setStateLoadingTemplate", true);
            return AuthServicesResetPassword(body,this.token)
                .then(response => {
                    this.showReset = true;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalRequest.invalid = true;
                    this.confirmPassword = '';
                    this.valid = false;
                    throw new Error("error to do login", error);
                })
                .finally(() => {
                    this.$store.commit("loadings/setStateLoadingTemplate", false);
                });

        }
    },

    mounted() {

        this.token = this.$route.params.token
        this.year = new Date().getFullYear();
        this.$store.commit('loadings/setStateLoadingTemplate', true);
        this.$store.commit('loadings/setStateLoadingTemplate', false);

        let colors = JSON.parse(localStorage.getItem('@datadrive:domain'))

        if (colors) {
            this.logo = colors.companyLogoBeforeLogin
            this.bgLogin = colors.backgroundImage
            this.titleLogin = colors.loginTitle
            this.subTitleLogin = colors.loginSubTitle
        }
    }
};
</script>

<style lang="scss" scoped>
    @import '@sass/_variables.scss';

    #login-app {
        // NOT GOOD - JUST FOR NOW
        height: 100vh;
        margin-left: -20px;
        margin-right: -20px;
        margin-top: -32px;

        .box--logo{
            @media (min-width: 1024px){
                margin-bottom:50px;
            }
            @media (min-width: 2000px){
                margin-bottom:150px;
            }

        }
        
        @media (max-width: 768px){
            height: auto;
            margin-left: -4px;
            margin-right: -4px;
            margin-top: -10px;
            margin-bottom: -10px;
        }

        .mb-50{
            margin-bottom:10%;
            @media (max-width: 768px){
                margin-bottom: 3%;
            }
        }
        .copyright {
            /*position: absolute;
            margin-left: 3%;
            bottom: 20px;*/
            color: white;
            font-size: 1em;
            z-index: 90;

            @media (max-width: 426px) {
                font-size: 0.8em;
            }
        }

        .btn-primary{
            background: var(--v-primary-base);
            border-color: var(--v-primary-base);
        }


        .background-div {

            background-size: cover !important;

            .container-box, .row-box, .container-col-box, .box-row {
                height: 100%;
            }

            .container-box, .row-box {
                padding: 0;
                margin: 0;
                height: 100vh;
            }

            .container-col-box {
                color: white;
                transition: 0.4s;
            }

            .p-left {
                margin-top: 45px;
                font-weight: 400;

                font-size: 3em;
                letter-spacing: 0.8px;
                line-height: 0.9em;
                transition: 0.4s;

                &.title{
                    text-shadow: 0 3px 6px var(--v-bgLogin-lighten4);
                    font-size: 75px !important;

                    @media (min-width: 2000px){
                        font-size: 90px !important;
                    }

                    span{
                        color: var(--v-primary-base);
                    }

                    @media (max-width: 768px){
                        font-size: 50px !important;
                    }
                }
                &.subtitle{
                    margin-top: 0;
                    font-size: 3em;
                    line-height: 72px;
                    font-weight: 400;

                    @media (min-width: 2000px){
                        font-size: 3em !important;
                    }

                    @media (max-width: 768px){
                        font-size: 30px;
                        line-height: 10px;
                        margin-bottom: 55px;
                    }

                    @media (max-width: 400px){
                        font-size: 20px;
                        line-height: 40px;
                        margin-bottom: 55px;
                    }
                }
            }




        }

        .login-div {
            .row-form-login{
                height: auto;
                background-color: var(--v-bgLogin-base);
                width: 100%;
                padding: 80px 90px 25px;
                align-content: center;
                display: inline-grid;
                float: right;
                border-radius: 20px;
                position: relative;
                max-width: 590px;

                @media(min-width: 2000px){
                    width: 565px;
                    padding: 80px 90px 25px;
                    min-height: 850px;
                }
                @media (max-width: 768px){
                    padding: 40px;
                    width: 450px;
                }
                @media (max-width: 425px){
                    padding: 20px;
                    width: 360px;
                }
                @media (max-width: 320px){
                    padding: 20px;
                    width: 300px;
                }

                .div-form-logo{
                    text-align: center;
                    margin-bottom: 50px;
                    img{
                        @media (max-width: 425px){
                            width: 100%;
                        }
                    }
                }
                .div-form-title {
                    span {
                        font-size: 32px;
                        line-height: 34px;
                        letter-spacing: 0.64px;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }


                .p-right {
                    font-size: 14px !important;
                    line-height: 16px !important;
                    letter-spacing: 0.14px !important;
                    font-weight: 400 !important;
                    color: #FFFFFF !important;
                    margin-top: 10px !important;
                }
            }

        }
    }

    ::v-deep .v-btn__content{
        @media (max-width: 768px){
            font-size: 10px;
        }
    }

    ::v-deep input:-webkit-autofill{
        transition: background-color 5000s ease-in-out 0s;
    }

    ::v-deep .login-remember label{
        margin-bottom: 0;
        color: #fff !important;
        @media (max-width: 768px){
            font-size: 10px;
            text-align: center;
            width: auto;
        }
    }

    ::v-deep .v-input--checkbox{
        @media (max-width: 768px){
            text-align: center;
            margin: 0 auto;
        }
        @media (max-width: 425px){
            width: 32% !important;
        }
        @media (max-width: 375px){
            width: 35% !important;
        }
        @media (max-width: 320px){
            width: 40% !important;
        }
    }

    ::v-deep .terms-codition .v-input--checkbox{
        @media (max-width: 768px){
            text-align: center;
            margin: 0 auto;
        }
        @media (max-width: 425px){
            width: 100% !important;
        }
        @media (max-width: 375px){
            width: 100% !important;
        }
        @media (max-width: 320px){
            width: 100% !important;
        }
    }
    .btn-recover{
        @media (max-width: 768px){
            margin-top: -15px;
        }
        @media (max-width: 425px){
            margin-top: 0;
        }

        ::v-deep .v-btn__content{
            font-size: 12px;
        }
    }

    ::v-deep label{
        font-size: 14px;
    }

    .btn-login{
        margin-top: 32px!important;

        @media (min-width: 2000px){
            margin-top:95px !important;
        }

        button{
            border-radius: 20px;
            font-size: 12px;
            padding: 10px;
        }
    }
    .div-form-logo{
        width: 250px;
        margin: 0 auto;
        img{
            object-fit: contain;
            max-width: 250px;
        }
    }

    button{
        text-transform: capitalize;
    }

    ::v-deep .v-alert__content {
        font-size: 12px;
    }
</style>
